/**
 * A FINS PO's value with tax (ENG-28003).
 *
 * FINS sends the pre-tax `amount` and the GST separately as `tax_amount`.
 * Invoices, payments and VIP's own credit-note check
 * (`revisedOrderValue = amount + tax_amount`) are all post-tax, as is the
 * `order_value` every other screen shows, so the revision and credit-note
 * screens compare and display this value too. Works for the live PO and its
 * revision draft alike.
 *
 * Kept as the one place that decides which PO value counts, should a vendor
 * ever be settled on the pre-tax value instead.
 *
 * Returns undefined when there is no PO amount, or when either figure isn't a
 * number — a NaN would slip past callers' `?? 0` and skew the credit-note
 * decision. A missing `tax_amount` counts as no tax (a 0% GST PO).
 */
export function poValueWithTax(po) {
  if (po?.amount == null) return undefined;
  const total = Number(po.amount) + Number(po.tax_amount ?? 0);
  if (!Number.isFinite(total)) return undefined;
  return Math.round(total * 100) / 100;
}
